import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {
  mb: (p) => p.spacing(1),
};

export const selectedIcon: SxStyleFunc<boolean | undefined> = (selected) => ({
  opacity: selected ? 1 : 0,
  color: (p) => p.palette.common.white,
});

export const colorBox: SxStyle = {
  // width: '100%',
  // height: (p) => p.spacing(2),
  borderRadius: (p) => p.spacing(0.25),
  cursor: 'pointer',
};
